import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../ui/Input';
import Button from '../ui/Button';
import { useApi } from '../../hooks/useApi';
import { API_ENDPOINTS } from '../../constants/api';
import { validateRegistration } from '../../utils/validation';
import useNotification from '../../hooks/useNotification';

const RegisterForm = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification();
  const [form, setForm] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    lastName: '',
    firstName: '',
    middleName: '',
    position: '',
    isAdmin: false
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { postData: registerUser } = useApi(API_ENDPOINTS.REGISTER);

  const handleInputChange = (field, value) => {
    setForm({ ...form, [field]: value });
    if (errors[field]) {
      setErrors({ ...errors, [field]: null });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validation = validateRegistration(form);
    if (!validation.isValid) {
      setErrors(validation.errors);
      return;
    }

    setIsLoading(true);
    try {
      const { confirmPassword, ...registrationData } = form;
      await registerUser(registrationData);
      showSuccess('Регистрация успешна! Теперь вы можете войти в систему.');
      navigate('/login');
    } catch (error) {
      console.error('Registration error:', error);
      showError(error.response?.data?.descr || 'Ошибка при регистрации');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-200">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-md w-96 space-y-4">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Регистрация</h2>
          <p className="text-gray-600">Создайте новую учетную запись</p>
        </div>
        
        <Input
          label="Email"
          type="email"
          value={form.email}
          onChange={(e) => handleInputChange('email', e.target.value)}
          placeholder="Введите email"
          error={errors.email}
          required
        />
        
        <Input
          label="Пароль"
          type="password"
          value={form.password}
          onChange={(e) => handleInputChange('password', e.target.value)}
          placeholder="Введите пароль"
          error={errors.password}
          required
        />
        
        <Input
          label="Подтвердите пароль"
          type="password"
          value={form.confirmPassword}
          onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
          placeholder="Повторите пароль"
          error={errors.confirmPassword}
          required
        />
        
        <Input
          label="Фамилия"
          value={form.lastName}
          onChange={(e) => handleInputChange('lastName', e.target.value)}
          placeholder="Введите фамилию"
          error={errors.lastName}
          required
        />
        
        <Input
          label="Имя"
          value={form.firstName}
          onChange={(e) => handleInputChange('firstName', e.target.value)}
          placeholder="Введите имя"
          error={errors.firstName}
          required
        />
        
        <Input
          label="Отчество"
          value={form.middleName}
          onChange={(e) => handleInputChange('middleName', e.target.value)}
          placeholder="Введите отчество"
          error={errors.middleName}
        />
        
        <Input
          label="Должность"
          value={form.position}
          onChange={(e) => handleInputChange('position', e.target.value)}
          placeholder="Введите должность"
          error={errors.position}
          required
        />

        <div className="flex items-center">
          <input
            id="isAdmin"
            name="isAdmin"
            type="checkbox"
            checked={form.isAdmin}
            onChange={(e) => handleInputChange('isAdmin', e.target.checked)}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <label htmlFor="isAdmin" className="ml-2 block text-sm text-gray-900">
            Создать как администратора
          </label>
        </div>

        <Button
          type="submit"
          variant="primary"
          loading={isLoading}
          className="w-full"
          disabled={isLoading}
        >
          {isLoading ? "Регистрация..." : "Зарегистрироваться"}
        </Button>
        
        <div className="text-center mt-4">
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="text-blue-600 hover:text-blue-800 text-sm underline"
          >
            Уже есть аккаунт? Войти
          </button>
        </div>
      </form>
    </div>
  );
};

export default RegisterForm; 